<template>
  <div style="border: 1px dashed grey; padding: 15px;">
    <v-textarea
      :label="label"
      v-model="newItem"
      filled
      append-icon="mdi-plus"
      @click:append="addItem()"
    ></v-textarea>
    <template v-if="value.length > 0">
      <v-card
        v-for="(item, index) of items"
        :key="index"
        class="ma-2"
        close
      >
        <v-card-text>
          <v-row>
            <v-col cols="10" @click="editItem(index)">
              <template v-if="!item.editMode">{{ item.value }}</template>
              <v-textarea
                v-else
                v-model="item.value"
                filled
                append-icon="mdi-content-save-all"
                @click:append="saveItem(index)"
              ></v-textarea>
            </v-col> 
            <v-col cols="2" class="d-flex" style="align-items:center;">
              <v-spacer></v-spacer>
              
              <div style="display: inline-block; width: 10px; margin-right:10px;">
                <v-icon small @click="upItem(index)">mdi-menu-up</v-icon>
                <v-icon small @click="downItem(index)">mdi-menu-down</v-icon>
              </div>
              <v-btn icon @click="deleteItem(index)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          
        </v-card-text>
      </v-card>
    </template>
    <span v-else class="ma-2">Отсутствуют данные.</span>
  </div>
</template>

<script>
export default {
  name: 'text-chips',
  
  props: {
    label: String,
    value: Array
  },

  data() {
    return {
      newItem: '',
      items: this.getItems()
    }
  },

  methods: {
    getItems() {
      return this.value.map(x => ({
        value: x,
        editMode: false
      }));
    },
    updateItems() {
      this.items = this.getItems();
    },
    addItem() {
      if (this.newItem) {
        this.value.push(this.newItem);
        this.newItem = '';
        this.updateItems();
      }
    },
    deleteItem(index) {
      this.value.splice(index, 1);
      this.updateItems();
    },
    editItem(index) {
      this.items[index].editMode = true;
    },
    saveItem(index) {
      this.value.splice(index, 1, this.items[index].value);
      this.updateItems();
    },
    upItem(index) {
      if (index > 0) {
        this.value.splice(index - 1, 2, this.value[index], this.value[index - 1]);
        this.updateItems();
      }
    },
    downItem(index) {
      if (index < this.value.length - 1) {
        this.value.splice(index, 2, this.value[index + 1], this.value[index]);
        this.updateItems();
      }
    }
  },

  filters: {
    chip(str) {
      if (str.length < 50) return str;
      return str.substr(0, 50) + '...';
    }
  },

  computed: {
    
  }
}
</script>